import React from 'react';
import { useIntl } from 'react-intl';

import { i18n } from './i18n.tsx';
import { QuickSummaryButtonWhitePlaceholder } from './QuickSummaryButtonWhitePlaceholder.tsx';
import type { QuickSummaryButtonStyles } from './QuickSummaryButton.tsx';

type QuickSummaryButtonPlaceholderProps = {
	summarizeText?: string;
	buttonStyles?: QuickSummaryButtonStyles;
};

export const QuickSummaryButtonPlaceholder = ({
	summarizeText,
	buttonStyles,
}: QuickSummaryButtonPlaceholderProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const buttonText = summarizeText ?? formatMessage(i18n.quickSummaryToolTipText);

	return (
		<QuickSummaryButtonWhitePlaceholder summarizeText={buttonText} buttonStyles={buttonStyles} />
	);
};
